import React, { createContext, useContext, useState } from 'react';
import { STATUS } from '../../utils/const';

const FilterContext = createContext({
  statusFilters: [],
  handleStatusFiltersChange: () => {},
  developmentStatusFilters: [],
  handleDevelopmentStatusFiltersChange: () => {},
  categoryFilters: [],
  handleCategoryFiltersChange: () => {},
  dateRange: {
    from: null,
    to: null
  },
  setDateRange: () => {},
  fixDateValue: null,
  setFixDateValue: () => {},
  resetFilters: () => {}
});

export const useFilterContext = () => useContext(FilterContext);

const FilterProvider = ({ defaultValues = {}, children }) => {
  const [ statusFilters, setStatusFilters ] = useState(defaultValues.statusFilters ?? []);
  const [ developmentStatusFilters, setDevelopmentStatusFilters ] = useState(
    defaultValues.developmentStatusFilters ?? []
  );
  const [ categoryFilters, setCategoryFilters ] = useState(
    defaultValues.categoryFilters ?? []
  );
  const [ dateRange, setDateRange ] = useState(
    defaultValues.selectedDateRange ?? {
      from: null,
      to: null
    }
  );
  const [ fixDateValue, setFixDateValue ] = useState(
    defaultValues.fixDateValue ?? null
  );

  const handleStatusFiltersChange = status => {
    const isNewFilter = !statusFilters.includes(status);
    const newStatusFilters = isNewFilter ?
      statusFilters.concat([ status ]) :
      statusFilters.filter(filter => filter !== status);

    setStatusFilters(newStatusFilters);
    if ((status === STATUS.ACTIVE && statusFilters.includes(STATUS.ACTIVE)) ||
      (statusFilters.length >= 1 && statusFilters.includes(STATUS.ACTIVE))) {
      setDevelopmentStatusFilters([]);
    }
  };

  const handleDevelopmentStatusFiltersChange = developmentStatus => {
    const isNewFilter = !developmentStatusFilters.includes(developmentStatus);
    const newDevelopmentStatusFilters = isNewFilter ?
      developmentStatusFilters.concat([ developmentStatus ]) :
      developmentStatusFilters.filter(filter => filter !== developmentStatus);

    setDevelopmentStatusFilters(newDevelopmentStatusFilters);
  };

  const handleCategoryFiltersChange = category => {
    const isNewFilter = !categoryFilters.includes(category);
    const newFilters = isNewFilter ?
      categoryFilters.concat([ category ]) :
      categoryFilters.filter(filter => filter !== category);

    setCategoryFilters(newFilters);
  };

  const resetFilters = () => {
    setStatusFilters([]);
    setDevelopmentStatusFilters([]);
    setCategoryFilters([]);
    setDateRange({
      from: null,
      to: null
    });
    setFixDateValue(null);
  };

  return (
    <FilterContext.Provider
      value={ {
        statusFilters,
        handleStatusFiltersChange,
        developmentStatusFilters,
        handleDevelopmentStatusFiltersChange,
        categoryFilters,
        handleCategoryFiltersChange,
        dateRange,
        setDateRange,
        fixDateValue,
        setFixDateValue,
        resetFilters,
        setStatusFilters,
        setDevelopmentStatusFilters
      } }
    >
      {children}
    </FilterContext.Provider>
  );
};

export default FilterProvider;